// Application-wide colors

export const white = '#FFFFFF';
export const lightestGrey = '#eeeeee';
export const superLightGrey = '#ebeff0';
export const lighterGrey = '#dddddd';
export const lightGrey = '#cccccc';
export const mediumLightGrey = '#aaaaaa';
export const mediumGrey = '#999999';
export const mediumDarkGrey = '#666666';
export const darkGrey = '#333333';
export const black = '#000000';
export const darkRed = '#db4628';
export const borderColor = '#e4e4e4';

export const appMainBackground = '#f1f1f1';
export const mainLoginBackground = '#ffde73';
export const dashboardGoalsBackground = '#4195d3';
export const appHeaderBackground = white;
export const appHeaderHilite = '#3d444e';
export const appFooterBackground = white;
export const dashboardGray = '#9b9aa2';
export const noEntitlementsGray = '#a5bacc';
export const placementBackground = '#071E38';
export const placementButtonBackground = '#A8D173';

export const appTextColor = '#4A4A4A';
export const footerTextColor = '#262626';
export const defaultBoxShadow = '2px 2px 6px 0px rgba(0,0,0,0.1)';

export const confirmationGreen = '#00b300';
export const lightBlueColor = '#34a3e7';
export const warningRedColor = darkRed;

export const blueEnabledColor = 'rgba(55, 82, 180, 1)';
export const blueDisabledColor = 'rgba(55, 82, 180, 0.5)';
export const blueHoverColor = '#5cbffb';
export const blueActiveColor = '#2085c2';

export const whiteHoverColor = '#e7e7e7';

export const focusedInputBorderColor = lightBlueColor;
export const unfocusedInputBorderColor = lightestGrey;

export const menuBackgroundColor = '#f6f6f6';
export const menuItemBorderColor = '#e6e6e6';
export const tableAlternateRowColor = '#f9f9f9';
export const menuHilitedColor = '#c9eafe';
export const menuSelectedColor = '#0f66d5';

export const mobileTextGrey = '#84898e';
export const mobileGoalLanguageGrey = '#fafafa';

export const spinnerColor = '#888888';
export const modalBackdropColor = 'rgba(0,0,0,0.4)';
export const darkModalBackdropColor = 'rgba(0,0,0,0.7)';

export const progressBarBackground = '#e6e6e6';
export const progressBarForeground = '#8FCE3E';

export const linkColor = '#3752B4';
export const verticalLine = '#cccccc';
export const workspaceLinkColor = '#02B1FF';
export const workspaceInputAlertColor = '#FA624D';



// WEBPACK FOOTER //
// ./src/styles/colors.js